import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { useEffect } from 'react';
import { useAdminTabs } from '@/groups/coordinator/useAdminTabs';

export const Route = createFileRoute(
  '/_app/_dashboard/groups/$groupName/admin/',
)({
  component: GroupAdminIndex,
});

/**
 * `/admin/` redirects to the first Settings tab for the group's type, as legacy
 * does, so the target depends on the group type. Both group sidebars link
 * Settings here.
 */
function GroupAdminIndex(): null {
  const { groupName } = Route.useParams();
  const navigate = useNavigate();
  const tabs = useAdminTabs();
  const firstTab = tabs[0]?.to;

  useEffect(() => {
    if (!firstTab) return;
    navigate({
      to: `/groups/$groupName/admin/${firstTab}`,
      params: { groupName },
      replace: true,
    });
  }, [firstTab, groupName, navigate]);

  return null;
}
